import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gl0013',
    ecrans: ['00-2']
});

